import { Component } from '@angular/core';
import { NavController, LoadingController } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { Globals } from '../../../../globals';
import { TPVServices } from '../../../tpv/services';


@Component({
  selector: 'page-configuration-printers-printservices',
  templateUrl: 'configuration-printers-printservices.html'
})

export class ConfigurationPrintersPrintservicesPage {


  constructor(public navCtrl: NavController,
    public globals: Globals,
    public http: HttpClient,
    public loadingCtrl: LoadingController,
    public tpvServices: TPVServices) {
    if (!this.globals.restaurant.printer_size) {
      this.globals.restaurant.printer_size = '80';
    }
  }

  openLink() {
    if (this.globals.so_mobile) {
      window.location.assign('https://printerservices.mycheftool.com/');
    } else {
      window.open('https://printerservices.mycheftool.com/', '_blank');
    }
  }



  async updateIonToggle(printer_cashdrawer) {
    this.globals.restaurant.printer_cashdrawer = printer_cashdrawer;
    this.tpvServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'printer_cashdrawer': printer_cashdrawer,
    });
  }

  downloadTutorial() {
    window.open('https://landing.mycheftool.com/storage/app/media/downloads/ZADIG_DRIVERS.zip', '_blank');

  }

  async setPaperSize(size) {
    this.tpvServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'printer_size': size,
    }).then(() => {
      this.globals.restaurant.printer_size = size;
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-thermal-printers/configuration-printers-printservices/configuration-printers-printservices.ts